module.exports = __webpack_public_path__ + "img/文化参观.a4af86d8.png";